module.exports = __webpack_public_path__ + "img/caseBuilder-electromechanicalEngineer.c36bf632.webp";